module.exports = [{"language-code":"en_US","value":"Legal notes"},{"language-code":"de_CH","value":"Rechtliche Hinweise"},{"language-code":"fr_CH","value":"notes legales"},{"language-code":"it_CH","value":"notas legales"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/LegalNotes.json
// module id = 478
// module chunks = 4